<template>
    <v-menu offset-y :nudge-bottom="13">
      <v-btn
        color="white"
        dark
        flat
        icon
        class="ml-3" 
        slot="activator"
      >
        <v-icon dark>apps</v-icon>
      </v-btn>
      <v-card class="menu-allapp pa-3">
        <div class="mb-3 font-weight-bold primary--text">Ứng dụng thuộc Tracking</div>
        <v-layout row wrap align-start class="pb-3" v-if="listApps.length">
          <template v-for="(app, index) in listApps">
            <v-flex xs4 :key="index" class="text-xs-center px-1" :class="{'coming-soon': !app.url}" v-if=" app.clientId === appClientIds.Tracking || app.clientId === appClientIds.SC">
              <a :href="app.url" target="_blank" class="app-link">
                <img :src="linkIcon + app.icon" v-if="app.icon" class="app-icon"/>
                <v-avatar size="40" class="app-icon" v-else>
                  <v-icon size="30">location_on</v-icon>
                </v-avatar>
                <p class="caption mt-1">{{ app.name }}{{!app.url ? ' (coming soon)' : null}}</p>
              </a>
            </v-flex>
          </template>
        </v-layout>
        <p class="font-italic" v-else>Chưa có ứng dụng.</p>

        <div class="mb-3 font-weight-bold primary--text">Ứng dụng thuộc Motrak</div>
        <v-layout row wrap align-start class="pb-3" v-if="listApps.length">
          <template v-for="(app, index) in listApps">
          <v-flex xs4 :key="index" class="text-xs-center px-1" :class="{'coming-soon': !app.url}" v-if="app.clientId === appClientIds.Motrak">
            <a :href="app.url" target="_blank" class="app-link">
              <img :src="linkIcon + app.icon" v-if="app.icon" class="app-icon"/>
              <v-avatar size="40" class="app-icon" v-else>
                <v-icon size="30">location_on</v-icon>
              </v-avatar>
              <p class="caption mt-1">{{ app.name }}{{!app.url ? ' (coming soon)' : null}}</p>
            </a>
          </v-flex>
          </template>
        </v-layout>
        <p class="font-italic" v-else>Chưa có ứng dụng.</p>

        <div class="mb-3 font-weight-bold primary--text">Ứng dụng thuộc Navi</div>
        <v-layout row wrap align-start class="pb-3" v-if="listApps.length">
          <template v-for="(app, index) in listApps">
          <v-flex xs4 :key="index" class="text-xs-center px-1" :class="{'coming-soon': !app.url}" v-if="app.clientId === appClientIds.Navi">
            <a :href="app.url" target="_blank" class="app-link">
              <img :src="linkIcon + app.icon" v-if="app.icon" class="app-icon"/>
              <v-avatar size="40" class="app-icon" v-else>
                <v-icon size="30">location_on</v-icon>
              </v-avatar>
              <p class="caption mt-1">{{ app.name }}{{!app.url ? ' (coming soon)' : null}}</p>
            </a>
          </v-flex>
          </template>
        </v-layout>
        <p class="font-italic" v-else>Chưa có ứng dụng.</p>

        <div class="text-xs-center">
          <a :href="'//' + 'apps.vietmap.vn'" target="_blank" class="app-link font-weight-medium blue--text text--darken-4">Xem tất cả</a>
        </div>
      </v-card>
    </v-menu>
</template>

<script>
import * as Utils from '../utils';
import * as Auth from '../utils/auth';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    listApps: [],
    linkIcon: process.env.LINK_ICON_APP,
    appClientIds: Utils.AppClientIDs
  }),

  methods: {
    ...mapActions(['getInternalApp']),

    async getApps () {
      await this.getInternalApp().then(res => {
        if (res && res.length) { 
          this.listApps = res;
        }
      });
    }
  }
};
</script>

<style scoped>
.menu-allapp{
  width: 310px;
  max-height: 365px;
  overflow: auto;
}
.app-link{
  color: initial;
  text-decoration: none;
}
img.app-icon{
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.app-icon{
  border: 1px solid #dadada;
  border-radius: 12px;
  height: 40px;
  width: 40px;
}
.coming-soon{
  opacity: 0.5;
}
.coming-soon .app-link {
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/AllApplications.vue